import React, { useState } from "react";
import axios from "axios";
import emailjs from "emailjs-com";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);

  const API_ENDPOINT = "https://solanthegroup.com/admin/api/contact"; 
  const USE_EMAILJS = false; // Toggle between API and EmailJS

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage(null);

    // Basic frontend validation
    if (!formData.name || formData.name.length < 3) {
      setResponseMessage("Name must be at least 3 characters.");
      setLoading(false);
      return;
    }
    if (!formData.email.includes("@")) {
      setResponseMessage("Please enter a valid email.");
      setLoading(false);
      return;
    }
    if (!formData.message) {
      setResponseMessage("Message cannot be empty.");
      setLoading(false);
      return;
    }

    if (USE_EMAILJS) {
      // Send via EmailJS
      emailjs
        .send(
          "YOUR_SERVICE_ID",
          "YOUR_TEMPLATE_ID",
          formData,
          "YOUR_USER_ID"
        )
        .then(
          (response) => {
            setResponseMessage("Message sent successfully!");
            setFormData({ name: "", email: "",  message: "" });
          },
          (err) => {
            setResponseMessage("Failed to send message. Try again.");
          }
        )
        .finally(() => setLoading(false));
    } else {
      // Send via Laravel API
      try {
        const response = await axios.post(API_ENDPOINT, formData);
        setResponseMessage(response.data.message);
        setFormData({ name: "", email: "", message: "" });
      } catch (error) {
        setResponseMessage(error.response?.data?.message || "Failed to submit. Try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      <form id="contact-form" onSubmit={handleSubmit}>
        <div className="contact-form-wrapper row">
          <div className="col-lg-6">
            <div className="form-group">
              <input
                className="input-field"
                name="name"
                placeholder="Name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <input
                className="input-field"
                name="email"
                placeholder="Email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <textarea
                className="input-field"
                name="message"
                placeholder="How can we help?"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-submit-group">
              <button className="tmp-btn btn-primary" type="submit" disabled={loading}>
                {loading ? "Sending..." : "Submit Now"}
              </button>
            </div>
          </div>
          {responseMessage && (
            <div className="col-lg-12 mt-3">
              <p className="text-info">{responseMessage}</p>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}
